import { useState, useEffect } from 'react';

/**
 * A custom hook that returns a debounced version of the provided value.
 * 
 * @param value The value to debounce.
 * @param delay The delay in milliseconds for the debounce.
 * @returns The debounced value.
 */
export const useDebounce = <T>(value: T, delay: number): T => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
